import { css } from '@emotion/css';

import { ScreenBreakpoint, Spacing } from '../../../styles';

export const mainContainer = css`
  min-height: 100vh;
  ${Spacing.ml64}

  @media (max-width: ${ScreenBreakpoint.mobile.max}) {
    ${Spacing.ml0}
    ${Spacing.p16}
  }
`;

export const title = ({ hasBacklink }: { hasBacklink: boolean }) => css`
  ${hasBacklink ? Spacing.mt20 : Spacing.mt64}
  ${Spacing.mb32}

  @media (max-width: ${ScreenBreakpoint.mobile.max}) {
    ${Spacing.my16}
  }
`;

export const backlinkButtonContainer = css`
  ${Spacing.mt8}
  ${Spacing.ml64}

  @media (max-width: ${ScreenBreakpoint.mobile.max}) {
    ${Spacing.ml16}
  }
`;
